const avatarUrl6 = '/avatars/user_avatar6.jpg';

const avatars = [
  '/avatars/user_avatar1.jpg',
  '/avatars/user_avatar2.png',
  '/avatars/user_avatar3.png',
  '/avatars/user_avatar4.png',
  '/avatars/user_avatar5.png',
  avatarUrl6
];

const USERS_LIST: any[] = [];

const avatarMap2 = USERS_LIST.reduce((acc, user, index) => {
  acc[user.id] = avatars[index % avatars.length];
  return acc;
}, {} as Record<string, string | undefined>);

export const getAvatarUrl = (userId: string) => {
  // TODO: change this to have a fallback URL. This is until we refactor the Sidebar Accordions
  return avatarMap2[userId] ?? avatarUrl6;
};
